module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "result",
    class: _vm.result.postType
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.result.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [(_vm.result.postType === 'extra') ? _c('span', [_vm._v("Extra •")]) : _vm._e(), _vm._v(" "), (_vm.result.number) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " •")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.resultTopics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.resultTopics), function(topic, index) {
    return _c('span', [(_vm.result.postType === 'episode') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'Category',
          params: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }) : _c('router-link', {
      attrs: {
        "to": {
          name: 'Extras',
          query: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.resultTopics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.result.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.result.slug
        }
      }
    }
  }, [_vm._v("More")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-684d8044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/SearchResult.vue
// module id = 789
// module chunks = 1